__webpack_require__.p = "https://static.cuemath.com/static/intel-admin/";